import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

type NoDataPageProps = {
  title: ReactNode;
  message?: string;
};

export const NoDataPage = ({ title, message }: NoDataPageProps) => (
  <Box
    sx={{ textAlign: "center", alignContent: "center", margin: "20vh auto" }}
  >
    <Typography variant="h5" component="p" gutterBottom>
      {title}
    </Typography>
    <Typography>{message}</Typography>
  </Box>
);
